import React, { useEffect, useState } from "react";
import HttpTool from "../../../../tool/HttpTool";
import { message, Spin, Button } from "antd";
import styles from "./BusinessChart.less";
import BaseChart from "../baseChart/BaseChart.tsx";
import { ReloadOutlined } from "@ant-design/icons";
import APILXD from "../../../../http/APILXD";

type Props = {
  pageParams: any;
  loading?: boolean;
}

export default function(props:Props) {
  const [loading, setLoading] = useState(props.loading || false);

  const [chartConfig, setChartConfig] = useState({
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c}台 ({d}%)'
    }
  });

  useEffect(() => {
    getData();
  }, [props.pageParams]);

  const getData= ()=>{
    setLoading(true)
    HttpTool.post(APILXD.businessSpaceStatistics, (code: any, msg: any, data: any) => {

      let seriesData = [];

      data.forEach(d => {
        seriesData.push({
          name: d.spaceName,
          value: d.deviceCount,
        })
      })

      setChartConfig((oldConfig)=>{
        let newConfig = {...oldConfig}
        newConfig.dataset = {
          dimensions: ['name', 'value'],
          source: data,
        }
        newConfig.series = [
          {
            type: 'pie',
            radius: ['0%', '70%'],
            itemStyle: {
              borderRadius: ['5%', '5%'],
            },
            label:{
              formatter: `{b}\n{c}台（{d}%）`,
            },
            data: seriesData
          },
        ];
        return newConfig;
      })

      setLoading(false)
    }, (code: any, msg: any) => {
      message.error(msg);
      setLoading(false)
    }, {
      ...props.pageParams,
    });
  }

  return <Spin wrapperClassName={styles.spinBoxStyle} spinning={loading}>
    <div className={styles.itemBox}>
      <div className={styles.title}>
        <Button
          type={'link'}
          icon={<ReloadOutlined />}
          onClick={() => {
            getData();
          }}
        />
        空间统计
      </div>
      <BaseChart
        chartType={"pie"}
        chartConfig={chartConfig}
      />
    </div>
  </Spin>;
}
